// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"65343867","309":"a65479f8","676":"331c70a8","876":"04e889e3"}[chunkId] + ".chunk.js";
};